import { isBuilderRichTextContainer } from '../../data-extractor/components-type-guards';
import { changeHeadingTagLevel } from './update-html-heading-data-object';
export const updateBuilderRichTextHeadingDataObject = (component, newTag) => {
  var _newDoc$body$firstEle;
  const {
    data,
    type
  } = component;
  if (!isBuilderRichTextContainer(data)) {
    throw new Error(`Component with type: ${type} is not a builder rich text component`);
  }
  const richText = data.richText;
  const oldHtml = richText.text;
  const parser = new DOMParser();
  const doc = parser.parseFromString(oldHtml, 'text/html');
  const oldHeadingElement = doc.body.firstElementChild;
  if (!oldHeadingElement) {
    throw new Error(`Old heading tag not found in builder rich text component data`);
  }
  const hasNonElementContent = Array.from(doc.body.childNodes).some(n => n.nodeType !== Node.ELEMENT_NODE && (n.textContent ?? '').trim().length > 0);
  const hasMultipleElements = doc.body.children.length > 1;
  if (hasNonElementContent || hasMultipleElements) {
    return component;
  }
  const oldTextContent = oldHeadingElement.textContent ?? '';
  const newHtml = changeHeadingTagLevel(newTag, oldHeadingElement);
  const newDoc = parser.parseFromString(newHtml, 'text/html');
  const newTextContent = ((_newDoc$body$firstEle = newDoc.body.firstElementChild) == null ? void 0 : _newDoc$body$firstEle.textContent) ?? '';
  const normalize = s => s.replace(/\s+/g, ' ').trim();
  if (normalize(oldTextContent) !== normalize(newTextContent)) {
    return component;
  }
  return {
    ...component,
    data: {
      ...data,
      richText: {
        ...richText,
        text: newHtml
      }
    }
  };
};
//# sourceMappingURL=update-builder-rich-text-heading-data-object.js.map